import React, { useEffect } from "react";
import { Box, InputBase } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const CourseSearchInput = ({
  searchQuery,
  setSearchQuery,
  suggestions,
  setSuggestions,
  showSuggestions,
  setShowSuggestions,
  highlightIndex,
  setHighlightIndex,
  onSearch,
  isSearchSubmitted,
  setIsSearchSubmitted = () => {},
  isShrunk,
  width = "100%",
}) => {
  useEffect(() => {
    if (isShrunk || isSearchSubmitted) {
      setShowSuggestions(false);
      setSuggestions([]);
      setHighlightIndex(-1);
    }
  }, [isShrunk, isSearchSubmitted]);

  console.log(suggestions, showSuggestions);

  return (
    <Box sx={{ position: "relative", width }}>
      {/* Input */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#fff",
          borderRadius: "15px",
          height: "30px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          px: 1,
        }}
      >
        <SearchIcon sx={{ fontSize: 18, color: "#757575", mr: 1 }} />

        <InputBase
          placeholder="Search Modules"
          value={searchQuery}
          onChange={(e) => {
            const value = e.target.value;

            // ✅ IMPORTANT: unlock suggestions immediately
            setIsSearchSubmitted(false);

            setSearchQuery(value);

            if (value.length > 2) {
              setShowSuggestions(true);
            } else {
              setShowSuggestions(false);
              setSuggestions([]);
              setHighlightIndex(-1);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "ArrowDown") {
              setHighlightIndex((prev) =>
                prev < suggestions.length - 1 ? prev + 1 : prev
              );
            } else if (e.key === "ArrowUp") {
              setHighlightIndex((prev) => (prev > 0 ? prev - 1 : -1));
            } else if (e.key === "Enter") {
              if (searchQuery.trim().length <= 2) return;

              // 🔒 lock + close
              setIsSearchSubmitted(true);
              setShowSuggestions(false);
              setSuggestions([]);
              setHighlightIndex(-1);
              const selected =
                highlightIndex >= 0
                  ? suggestions[highlightIndex]?.name
                  : searchQuery;
              onSearch(selected);
              setSearchQuery("");
            }
          }}
          sx={{ flex: 1, fontSize: "14px" }}
        />
      </Box>

      {/* Suggestions */}
      {showSuggestions && suggestions.length > 0 && (
        <Box
          sx={{
            position: "absolute",
            top: "35px",
            left: 0,
            width: "100%",
            backgroundColor: "#fff",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            zIndex: 1000,
            borderRadius: "8px",
            maxHeight: "200px",
            overflowY: "auto",
            fontSize: "14px",
          }}
        >
          {suggestions.map((item, index) => (
            <Box
              key={index}
              onClick={() => {
                setIsSearchSubmitted(true);
                setShowSuggestions(false);
                setSuggestions([]);
                setHighlightIndex(-1);
                onSearch(item.name);
                setSearchQuery("");
              }}
              sx={{
                px: 2,
                py: 1,
                cursor: "pointer",
                backgroundColor:
                  highlightIndex === index ? "#f0f0f0" : "transparent",
                "&:hover": { backgroundColor: "#f0f0f0" },
              }}
            >
              {item.name}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default CourseSearchInput;
